<template>
    <div 
        id="gallery_wrapper" 
        class="upload_file" 
        :class="{
            single: settings.max == 1, 
            input_box_style: isInputBox, 
            small: !isInputBox, 
            uploading: isUploading
        }"
    >
        <GalleryList
            v-if="loaded"
            :gallery="gallery"
            :settings="settings"
            :is-uploading="isUploading"
            :percent-complete="percentComplete"
            :max-width="max_width"
            :is-input-box="isInputBox"
            :custom-label="customLabel"
            :uploadboxs="uploadboxs"
            :watch-only="watchOnly"
            @choose-files="chooseFiles"
            @remove="remove"
            @drop="handleDrop"
            @add-uploadbox="addUploadbox"
            @update-uploadbox="updateUploadbox"
            @upload-directly="uploadDirectly"
        />
        <input 
            type="file" 
            ref="fileUpload" 
            hidden 
            @change="handleFileInput"
        >
    </div>
</template>

<script>
import axios from 'axios';
import GalleryList from './gallery/GalleryList.vue';

export default {
    name: 'GalleryInput',
    
    components: {
        GalleryList
    },

    props: {
        modelValue: {
            required: true
        },
        token: {
            type: String,
            required: false
        },
        max: {
            type: Number,
            required: false
        },
        pay: {
            required: false
        },
        max_width: {
            type: Number,
            required: false
        },
        client_id: {
            required: false
        },
        isInputBox: {
            type: Boolean,
            default: false
        },
        customLabel: {
            type: String,
            default: 'העלאת קובץ'
        },
        watchOnly: {
            type: Boolean,
            default: false
        }
    },

    emits: ['update:modelValue', 'onUpload'],

    data() {
        return {
            isUploading: false,
            percentComplete: 0,
            gallery: [],
            loaded: false,
            settings: {
                max: this.max || 999
            },
            uploadboxs: [],
            activeUploadIndex: null
        };
    },

    mounted() {
        this.initializeGallery();
        console.log(this.gallery.length, "gallery ", this.settings.max);
        if(this.gallery.length === 0 && !this.watchOnly) {
            this.addUploadbox();
        }
    },

    computed: {
        uploadFileText() {
            return this.customLabel || this.get_word('upload_file');
        }
    },

    methods: {
        initializeGallery() {
            console.log(this.modelValue, "ll");
            
            if (this.modelValue && +this.modelValue > 0) {
                this.api({ 
                    action: 'upload_file/get', 
                    data: { id: this.modelValue } 
                }, (data) => {
                    if (!data.data) {
                        this.gallery.push(this.modelValue);
                    } else {
                        this.gallery.push(data.data);
                    }
                    this.loaded = true;
                });
            } else if (this.modelValue && this.modelValue.length > 0 && this.modelValue !== '0') {
                this.gallery = [...this.modelValue];
                this.loaded = true;
            } else {
                this.gallery = [];
                this.loaded = true;
            }
        },

        updateGalleryValue() {
            const val = this.gallery.length > 0 ? this.gallery : 0;
            this.$emit('update:modelValue', val);
        },

        handleDrop(e, index) {
            e.preventDefault();
            const files = e.dataTransfer.files;
            if (files?.length) {
                this.handleFiles(files[0], index);
            }
        },

        handleFileInput(e) {
            const files = e.target.files;
            if (files?.length) {
                this.handleFiles(files[0], this.activeUploadIndex);
            }
        },

        handleFiles(file, index) {
            if (this.watchOnly || (this.uploadboxs[index]?.isUploading)) return;

            const formData = new FormData();
            formData.append('token', this.token);
            formData.append('file', file);

            this.uploadFile(formData, index);
        },

        uploadFile(formData, index) {
            if (this.uploadboxs[index]?.isUploading) return;
            this.updateUploadbox(index, { isUploading: true, percentComplete: 0 });

            const headers = { 
                'Content-Type': 'multipart/form-data', 
                'Accept': 'application/json' 
            };
            
            if (localStorage.getItem('user_token')) {
                headers.Authorization = localStorage.getItem('user_token');
            }

            axios({
                method: 'post',
                url: window.api_url + 'upload_file/upload',
                data: formData,
                responseType: 'json',
                headers,
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.event?.lengthComputable) {
                        let prog = (progressEvent.loaded / progressEvent.total) * 100;
                        if (prog === 100) prog = 99;
                        this.updateUploadbox(index, { percentComplete: Math.floor(+prog) });
                    }
                },
            }).then(response => {
                if (response.data === 'error') {
                    localStorage.removeItem('user_token');
                    document.location.reload();
                    return;
                }

                this.gallery.push(response.data.data);
                this.updateGalleryValue();
                this.$emit('onUpload', response.data.data);
                
                // Remove used upload box
                this.uploadboxs.splice(index, 1);
                
                // Add upload box if none left and no files are uploaded yet
                if (this.uploadboxs.length === 0 && this.gallery.length === 0) {
                    this.addUploadbox();
                }
            }).catch(error => {
                console.error('Upload error:', error);
            }).finally(() => {
                if (this.uploadboxs[index]) {
                    this.updateUploadbox(index, { isUploading: false, percentComplete: 0 });
                }
            });
        },

        chooseFiles(index) {
            if (this.watchOnly) return;
            this.$refs.fileUpload.click();
            this.activeUploadIndex = index;
        },
        
        uploadDirectly() {
            if (this.watchOnly) return;
            
            // Create a temporary index for the direct upload
            const tempIndex = 0;
            
            // Set this as the active upload index
            this.activeUploadIndex = tempIndex;
            
            // Trigger the file input click
            this.$refs.fileUpload.click();
        },

        remove(pic) {
            if (this.watchOnly) return;
            
            const tempGallery = [...this.gallery];
            const index = this.gallery.findIndex(item => item.id === pic.id);
            
            if (index !== -1) {
                this.gallery.splice(index, 1);
            }

            this.superToast(true, this.get_word('deleted_gallery'), true, 3000).then(() => {
                this.api({
                    action: 'upload_file/remove',
                    data: { id: pic.id, token: this.token }
                }, () => {
                    if (this.max === 1) {
                        this.gallery = [];
                    }
                    this.updateGalleryValue();
                    
                    // Add upload box if no files are left
                    if (this.gallery.length === 0 && this.uploadboxs.length === 0) {
                        this.addUploadbox();
                    }
                });
            }).catch(() => {
                this.gallery = tempGallery;
            });
        },

        addUploadbox() {
            if (!this.watchOnly) {
                this.uploadboxs.push({
                    isDragover: false,
                    isUploading: false,
                    percentComplete: 0
                });
            }
        },

        updateUploadbox(index, updates) {
            if (this.uploadboxs[index]) {
                this.uploadboxs[index] = {
                    ...this.uploadboxs[index],
                    ...updates
                };
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.payment_success_wrapper~#gallery_wrapper ul li:not(:last-child){
    @media (max-width: 600px) {border-top: 1px solid #E6E9EF;}
    @media (min-width: 600px) {}
}
.single-line-clamp {
line-clamp: 1;
    --webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
#gallery_wrapper { width: 100%; height: 100%; position: relative;
    &.small { height: unset; overflow: hidden;

        .content { gap: var(--gap_small); display: flex; align-items: center; justify-content: center;
            // padding: var(--gap_small) var(--gap_xmid);
            flex-direction: row-reverse !important;
            p {white-space: nowrap;}
            p, .icon_container { z-index: 1;}
            .icon {
                width: 18px !important; height: 18px !important;
            }
            &::after { content: ''; position: absolute; top: 0; bottom: 0; right: 0; width: var(--percentComplete); background: var(--pageBG);}
            
        }
    }
    &.uploading { border-color: var(--dark_blue); 
        .add .pic .content {
            p { color: var(--dark_blue); }
            // .icon { background: var(--dark_blue);}
        } 
    }
    // &{padding: 10px  0;}
    .add { cursor: pointer;
        .pic { 
            &{ }
            @media (max-width: 600px) {}
            // @media (min-width: 600px) {background:#F5F6F8;}
            &:not(.payment) {
                // .content {border-radius: 12px;  display: flex;  align-items: center; justify-content: center; text-align: center; gap:15px; 

                //     @media (max-width: 600px) {justify-content: flex-start;gap: var(--gap);width: 100%;}
                //     @media (min-width: 600px) {inset: 15px;position: absolute;padding: 25px;flex-direction: column;border:2px dashed var(--primary_color); }

                //     h3 {font-size: 18px;
                //         @media (max-width: 600px) {flex-basis: 50%;}
                //         @media (min-width: 600px) {}
                //     }
                //     i { color: var(--primary_color); font-size: 26px;}

                // }
            }

            &.payment {
                // &{height: 50px;line-height: 1;background: #f5f6f8;border-radius: 10px;}
                // .content {display: flex;justify-content: center;gap:10px;}
            }

            .content { display: flex; flex-direction: column; justify-content: center; align-items: center;
                .icon_container {
                    .icon { width: 32px; height: 32px;}
                }
                p {color: var(--ligth_color);}
                
                // .progress_bar {width: 100%;height: 25px;padding: 0;}
                // &.uploading {justify-content: space-around;}
            }
            &.is-dragover{
                &{background: #e0e2e4;}
                &>* { pointer-events: none;}
            }
        }
    }


    &.single {
        ul { display: block; 
            @media (max-width: 600px) {}
            // @media (min-width: 600px) {max-width: 260px;}
            li { height: 100%;}
        }
    }

    .pic {  padding-inline: 10px; min-height: 40px;
        
        &:not(.payment) {
            &{width: 100%;display: flex;}
            @media (max-width: 600px) {gap:12px;padding:15px;}
            // @media (min-width: 600px) {gap:15px;aspect-ratio: 1;background:#f5f6f8;padding:15px;border-radius: 30px;flex-direction: column;}
            .inner { display: flex !important; justify-content: center; align-items: center;
                &{background:#fff cente r center no-repeat; background-size: cover; overflow: hidden; display: block; border-radius: 15px; padding: 8px; flex:1;}

                @media (max-width: 600px) {display: flex;justify-content: space-between;align-items: center;}
                @media (min-width: 600px) {}

                p { width: fit-content; }
                // h3 {  border-radius: 6px; text-align: center; color: #000; font-weight: normal;
                //     @media (max-width: 600px) {font-size: var(--h5);order: -1;}
                //     @media (min-width: 600px) {font-size: var(--h6);}
                // }
            }
        }
        &.payment{
            // &{display: flex;gap:10px;height: fit-content;padding:15px; background:#f5f6f8; border-radius: 10px;}
            @media (max-width: 600px) {width: 100%;justify-content: space-between;}
            @media (min-width: 600px) {flex-direction: column;}
            .inner { 
                &{background:#fff center center no-repeat;overflow: hidden; display: block; border-radius: 10px; padding: 8px; flex:1;}
                h3 { font-size: var(--h5); background: rgba(255,255,255,0.5); border-radius: 6px; text-align: center; color: #000; font-weight: normal;}
            }
        }
        &.confirmed { height: 100%;
            @media (max-width: 600px) {}
            @media (min-width: 600px) {background: #4d7e994a;}

            .inner {

                h3{
                    @media (max-width: 600px) {font-weight: bold;color: var(--primary_color);}
                    @media (min-width: 600px) {}
                }
            }
        }
        .actions { 
            &{display: flex; gap:8px;  align-items: center;  justify-content: center;}
            @media (max-width: 600px) {align-items: center;}
            @media (min-width: 600px) {}

            a { height: fit-content;}

            &:empty{display: none;}

            .btn { width: fit-content; padding: 10px 15px; font-weight: bold; font-size: 14px; height: auto;
                @media (max-width: 600px) {font-size: 12px;}
                @media (min-width: 600px) {font-size: 14px;}
            }
            .btn.bordered { font-weight: bold;
                &.confirm_btn{
                    @media (max-width: 600px) {font-weight: 400;}
                    @media (min-width: 600px) {}
                }
            }
            .remove { 
                @media (max-width: 600px) {background-color: transparent;padding: 0;}
                @media (min-width: 600px) { color:#fff;}

                :deep(path){  
                    @media (max-width: 600px) {color: var(--alert); fill:var(--alert);}
                    @media (min-width: 600px) {color: #fff; fill:#fff;}
                }

                i, svg{ color: #000;
                    @media (max-width: 600px) {width: 20px;height: 20px;}
                    @media (min-width: 600px) {}
                }
            }
        }
        .moderation { position: absolute; bottom: 0px; right: 0px; left: 0px; text-align: center; font-size: 11px; background: rgba(0, 0, 0, 0.5); margin: 0 auto; color: #fff;}

    }

    &.input_box_style{
        @media (max-width: 600px) {border-radius: var(--radius);padding: 0;background-color: var(--bg_color);}
        @media (min-width: 600px) {}
        ul {
                li {
                    
                    &:not(.add){
                        .pic{padding: 5px;    height: 100%;
                            .inner{background: transparent;
                                h3{background: transparent;text-align: right;}

                            }
                        }
                    }

                    &.add .pic{padding-inline: 20px;
                        @media (max-width: 600px) {padding: 16px 12px;height: var(--btn_height_lg);}
                        @media (min-width: 600px) {}

                        // .content{
                        //     h3{
                        //         @media (max-width: 600px) {font-weight: normal;text-align: right;}
                        //         @media (min-width: 600px) {}
                        //     }
                        // }
                        
                    }

            }
        }
    }
    
    .confirmed_sign {
        &{display: flex;justify-content: flex-start; align-items: center; font-weight: bold;gap: 5px;line-height: 1;}
        @media (max-width: 600px) {font-size: 18px;}
        @media (min-width: 600px) {font-size: 22px;}
        // .confirm {background: url(../assets/confirm.svg);background-size: contain;
        //     @media (max-width: 600px) {width: 16px;height: 16px;}
        //     @media (min-width: 600px) {width: 30px;height: 30px;}
        // }
        i{padding-left: 10px;color:var(--primary_color)}
    }
}
// .progress {
//     &{display: flex; align-items: center; height: 40px; background: #fff; border-radius: 12px; position: relative; padding: 6px;width: 100%;}
//     .amount {min-width: fit-content;padding: 10px;transition: width 0.7s;font-weight: bold;display: flex; justify-content: flex-end; align-items: center;padding-left: 10px;color:var(--primary_text_color);height: 100%; background: linear-gradient(90deg, var(--dark_blue), var(--primary_color));border-radius: 8px;}
// }
// .progress { height: ;
//     &{display: flex; align-items: center; height: 40px; background: #fff; border-radius: 12px; position: relative; padding: 6px;width: 100%;}
//     .amount {min-width: fit-content;padding: 10px;transition: width 0.7s;font-weight: bold;display: flex; justify-content: flex-end; align-items: center;padding-left: 10px;color:var(--primary_text_color);height: 100%; background: linear-gradient(90deg, var(--dark_blue), var(--primary_color));border-radius: 8px;}
// }
</style>